import { useCallback } from 'react';

import IconDropdown from 'approot/shared/icons/icon-dropdown';
import { DIRECTION, DIRECTION_LEFT, AnyObject } from 'webclient.constants';
import { ReorderHandler } from 'approot/shared/content/content.constants';
import { ReorderStyled } from './reorder.style';

type Props = {
  buttonTitle: string;
  direction: DIRECTION;
  content: AnyObject;
  handleReorder?: ReorderHandler;
  disabled?: boolean;
};

const Reorder = ({
  buttonTitle,
  direction,
  content,
  handleReorder,
  disabled,
}: Props) => {
  const handleClick = useCallback(() => {
    if (handleReorder) handleReorder(direction, content);
  }, [content, direction, handleReorder]);

  return (
    <ReorderStyled
      data-selector="reorder"
      title={`${
        direction === DIRECTION_LEFT ? 'Move left' : 'Move right'
      } (${buttonTitle})`}
      onClick={handleClick}
      $direction={direction}
      $disabled={disabled}
      disabled={disabled}
    >
      <IconDropdown width={18} height={18} />
    </ReorderStyled>
  );
};

export default Reorder;
